import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../api";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [cf, setCf] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast({ title: "Too short", description: "Password must be at least 8 characters", variant: "destructive" }); return; }
    if (pw !== cf) { toast({ title: "Passwords don't match", variant: "destructive" }); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast({ title: "Password updated", description: "You can now sign in with your new password." });
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast({ title: "Could not reset password", description: err?.response?.data?.detail || "The link may be invalid or expired.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout title="Invalid reset link" subtitle="This password reset link is missing or malformed.">
        <Link to="/forgot-password" className="gp-btn-teal inline-block rounded-xl px-6 py-3 font-medium" data-testid="request-new-link">Request a new link</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Choose a new password" subtitle="Enter a new password for your account below.">
      {done ? (
        <div data-testid="reset-done" className="rounded-xl bg-[#eefafa] border border-[#c9efef] p-5 text-[#16243b]">
          <p className="font-medium">Password updated</p>
          <p className="text-sm text-[#5a6b80] mt-1">Redirecting you to sign in…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#16243b] mb-1.5">New password</label>
            <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-new"
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="At least 8 characters" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#16243b] mb-1.5">Confirm new password</label>
            <input type="password" required value={cf} onChange={(e) => setCf(e.target.value)} data-testid="reset-confirm"
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="Re-enter password" />
          </div>
          <button disabled={loading} data-testid="reset-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
